import { dbGet, ErrorT } from '../helper-api';
import { ProjectClientT } from 'bovaljaren-models';


const ProjectApi = {
    getProjectWithDataFromId: async (projectId: number, fetch = window.fetch): Promise<Response | ErrorT> => {
        const response = dbGet<ProjectClientT>(`${projectId}/withData`, fetch);

        return response;
    }
};

export default ProjectApi;